import React, { memo, useState } from "react";
import PlaceholderImagenMitico from "./PlaceholderImagenMitico";
import BotonFavoritoProducto from "./BotonFavoritoProducto";
import { esImagenValida } from "../../utils/imagenes";

function ImagenProductoHorizontal({ prod, logoNegocio }) {
  const [imagenRota, setImagenRota] = useState(false);

  const tieneImagen = esImagenValida(prod?.imagen) && !imagenRota;

  if (!tieneImagen) {
    return <PlaceholderImagenMitico logoNegocio={logoNegocio} />;
  }

  return (
    <img
      src={prod.imagen}
      alt={prod.nombre}
      loading="lazy"
      decoding="async"
      onError={() => setImagenRota(true)}
      style={{
        width: "100%",
        height: "110px",
        borderRadius: "12px",
        objectFit: "cover",
        marginBottom: "8px",
        display: "block",
      }}
    />
  );
}

function SeccionProductosHorizontal({
  titulo,
  subtitulo,
  productos = [],
  logoNegocio,
  onAbrirProducto,
  mostrarBotonFavorito = false,
  favoritosIds = [],
  onToggleFavorito,
}) {
  if (!productos.length) {
    return null;
  }

  return (
    <div style={{ padding: "15px 0 20px 16px" }}>
      <h3
        style={{
          margin: "0 0 2px 0",
          fontSize: "17px",
          fontWeight: "900",
          letterSpacing: "-0.5px",
        }}
      >
        {titulo}
      </h3>

      {subtitulo && (
        <p style={{ margin: "0 0 12px 0", fontSize: "12px", color: "#666" }}>
          {subtitulo}
        </p>
      )}

      <div
        style={{
          display: "flex",
          gap: "12px",
          overflowX: "auto",
          padding: "2px 16px 4px 2px",
          scrollBehavior: "smooth",
          scrollSnapType: "x proximity",
          scrollbarWidth: "none",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {productos.map((prod) => {
          const favoritoActivo = favoritosIds.includes(prod.id);

          return (
            <div
              key={prod.id}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 24px rgba(0,0,0,0.10)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.06)";
              }}
              style={{
                backgroundColor: "#fff",
                width: "165px",
                borderRadius: "16px",
                padding: "10px",
                flexShrink: 0,
                scrollSnapAlign: "start",
                border: "1px solid #eef",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                transition: "transform .18s ease, box-shadow .18s ease",
                position: "relative",
                cursor: "pointer",
              }}
            >
              {mostrarBotonFavorito && (
                <BotonFavoritoProducto
                  productoId={prod.id}
                  activo={favoritoActivo}
                  onToggle={onToggleFavorito}
                  size={30}
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    zIndex: 3,
                  }}
                />
              )}

              <div>
                <ImagenProductoHorizontal
                  prod={prod}
                  logoNegocio={logoNegocio}
                />

                <h4
                  style={{
                    margin: "0 0 2px 0",
                    fontSize: "13px",
                    fontWeight: "800",
                    lineHeight: "1.25",
                    height: "34px",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {prod.nombre}
                </h4>

                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "800",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  ${prod.precio}
                </span>
              </div>

              <button
                type="button"
                onClick={() => onAbrirProducto(prod)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.03)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
                onTouchStart={(e) => {
                  e.currentTarget.style.transform = "scale(0.97)";
                }}
                onTouchEnd={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
                onTouchCancel={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
                style={{
                  width: "100%",
                  background: "linear-gradient(135deg,#111,#2d2d2d)",
                  color: "#fff",
                  border: "none",
                  padding: "10px 0",
                  borderRadius: "10px",
                  fontSize: "12px",
                  fontWeight: "800",
                  letterSpacing: "0.3px",
                  cursor: "pointer",
                  transition: "transform .18s ease",
                }}
              >
                Agregar
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(SeccionProductosHorizontal);
